import React from "react";
import userIMG from "../Assest/images/user-img.jpg";

const EditProfile = () => {
  const getProfileData = () => {
    const data = localStorage.getItem("profiledata");
    return data ? JSON.parse(data) : null;
  };

  console.log(getProfileData());

  return (
    <div className="page">
      {/* PAGE HEADING */}

      <h4 className="title mb-3">Edit Profile</h4>

      <div className="">
        {/* PROFILE HEADER */}
       

        {/* FORM */}
        <form className="row">
          <div className="col-lg-6">
            <div className="form-group m-b25">
              <label className="label-title"> Name</label>
              <input
                className="form-control1"
                value={getProfileData()?.name}
                readOnly
              />
            </div>
          </div>

          <div className="col-lg-6">
            <div className="form-group m-b25">
              <label className="label-title">Email address</label>
              <input
                className="form-control1"
                value={getProfileData()?.email}
                readOnly
              />
            </div>
          </div>

          <div className="col-lg-6">
            <div className="form-group m-b25">
              <label className="label-title">password</label>
              <input
                className="form-control1"
                value={getProfileData()?.name}
                readOnly
              />
            </div>
          </div>
        </form>

        {/* FOOTER */}
        <div className="d-flex flex-wrap justify-content-between align-items-center">
          <div className="form-group">
            <div className="custom-control custom-checkbox text-black">
              <input
                type="checkbox"
                className="form-check-input"
                id="newsletterCheck"
              />
              <label className="form-check-label" htmlFor="newsletterCheck">
                Subscribe me to Newsletter
              </label>
            </div>
          </div>

          <button className="add-cart-btn w-auto mt-3 mt-sm-0">
            Update Profile
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditProfile;
